import './Header.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { openDrawer } from "../slices/drawerSlice";
import { fetchUser } from "../slices/userSlice";

import Menu from "@mui/icons-material/Menu";

import { Profile } from "../common-components/Profile/Profile";
import { IconButton } from "../common-components/Buttons/Buttons";

import ProfileCard from "../profile-card/ProfileCard";
import ProfileFooter from "../profile-card/components/ProfileFooter/ProfileFooter";
import ProfileTools from "../profile-card/components/ProfileTools/ProfileTools";

const Header = ({onOpen}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const data = useSelector((state) => state.user.data);

    useEffect(() => {
        dispatch(fetchUser({token}));
    }, [dispatch, token]);

    const handleOpen = () => {
        dispatch(openDrawer({tools: <ProfileTools/>, content: <ProfileCard/>, footer: <ProfileFooter/>}));
    }

    return (
        <div className={"header"}>
            <div className={"header_container"}>
                <div className={"header_left_section"}>
                    <div className={"header_burger"}>
                        <IconButton
                            Icon={Menu}
                            onClick={onOpen}
                        />
                    </div>
                </div>
                <div className={"header_right_section"}>
                    <div className={"header_profile"} onClick={handleOpen}>
                        <Profile
                            firstName={`${data?.attributes?.first_name}`}
                            lastName={`${data?.attributes?.last_name}`}
                            showName={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;